import { EmailEntityId } from "@sp-crm/core";
import React from "react";
import { useGetConversationFeedForEntityQuery } from "../../generated/graphql";
import { ErrorMessage } from "../ui/error-message";
import { Spinner } from "../ui/spinner";
import { ConversationFeed } from "./conversation-feed";
import { MailboxSyncMessages } from "./mailbox-sync-messages";

interface SentMessagesProps {
    entityId: EmailEntityId;
    showClient: boolean;
    showCommunity: boolean;
}

export const SentMessages: React.FC<SentMessagesProps> = props => {
    const { showClient, showCommunity } = props;

    const query = useGetConversationFeedForEntityQuery({ entityId: props.entityId });

    if (query.isLoading) {
        return <Spinner />;
    }
    if (query.isError) {
        return (
            <ErrorMessage component="SentMessages">
                <pre>{JSON.stringify(query.error, null, 2)}</pre>
            </ErrorMessage>
        );
    }
    if (!query.data) {
        return <Spinner />;
    }

    return (
        <>
            <MailboxSyncMessages entityId={props.entityId} />
            <ConversationFeed
                feed={query.data.getConversationFeedForEntity}
                showClient={showClient}
                showCommunity={showCommunity}
            />
        </>
    );
};
